import { graphql } from '../graphql';

export const layersQuery = graphql(`
  query Layers($projectId: ID!) {
    layers(projectId: $projectId) {
      id
      parentLayerId

      name
      description

      type
      root
      metadata

      bbox
      bboxNew
      center

      isHidden
      isLocked

      propertyAliases {
        property
        alias
      }

      createdAt
      updatedAt

      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
      }
    }
  }
`);

export const createLayerMutation = graphql(`
  mutation CreateLayer($input: CreateLayerInput!) {
    createLayer(input: $input) {
      id
    }
  }
`);

export const updateLayerMutation = graphql(`
  mutation UpdateLayer($input: UpdateLayerInput!) {
    updateLayer(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`);

export const deleteLayerMutation = graphql(`
  mutation DeleteLayer($id: ID!) {
    deleteLayer(id: $id)
  }
`);

export const layerQuery = graphql(`
  query Layer($id: ID!) {
    layer(id: $id) {
      id
      parentLayerId

      name
      description

      type
      root
      metadata

      bbox
      bboxNew
      center

      isHidden
      isLocked

      createdAt
      updatedAt

      sourceAttachment {
        batchId
        filename
        contentLength
        createdAt
      }

      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
      }
    }
  }
`);

export const updateLayerSettingsMutation = graphql(`
  mutation UpdateLayerSettings($id: ID!, $input: LayerSettingsInput!) {
    updateLayerSettings(id: $id, input: $input)
  }
`);

export const layerSettingsQuery = graphql(`
  query LayerSettings($id: ID!) {
    layer(id: $id) {
      id
      settings {
        pointCloudMaterialColorSource
        pointCloudMaterialColor
        pointCloudFixedColor
        modelIsWireframe
        modelDefaultColor
        pointCloudClasses {
          color
          isEnabled
        }
        imagePointColor
        vectorDefaultColor
        vectorDefaultOpacity
        vectorIsWireframe
        vectorDefaultPointSize
      }
    }
  }
`);

export const layerPropertiesQuery = graphql(`
  query LayerProperties($layerId: ID!) {
    layerProperties(layerId: $layerId)
  }
`);

export const layerPropertyValuesQuery = graphql(`
  query LayerPropertyValues($layerId: ID!) {
    layerPropertyValues(layerId: $layerId) {
      property
      values
    }
  }
`);
